// extracted by mini-css-extract-plugin
module.exports = {"toggleEntry":"_3t7DX6SJOyF5l79UPY4mDL"};